import { render, staticRenderFns } from "./ResizeCtrl.vue?vue&type=template&id=4a41cd5f&scoped=true&"
import script from "./ResizeCtrl.vue?vue&type=script&lang=js&"
export * from "./ResizeCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41cd5f",
  null
  
)

export default component.exports